import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

/**
 * Generic content link component that opens content in modal or navigates based on context
 * Can be used for calculators, resources, or any other content type
 */
const ContentLink = ({ 
  contentId, 
  children, 
  className = "",
  useModalHook,
  modalComponent: ModalComponent,
  contentType = "calculator", // default for backward compatibility
  ...props 
}) => {
  const navigate = useNavigate();
  const hookResult = useModalHook();
  const { modalState, closeModal } = hookResult;
  
  // open method (could be openCalculator, openResource, or openContent)
  const openMethod = hookResult.openCalculator || hookResult.openResource || hookResult.openContent;

  const handleClick = (e) => {
    e.preventDefault();
    if (openMethod) {
      openMethod(contentId, navigate);
    }
  };

  return (
    <>
      <a
        href={`/${contentType}/${contentId}`}
        className={className}
        onClick={handleClick}
        {...props}
      >
        {children}
      </a>
      
      {/* Content Modal - only renders when needed */}
      <ModalComponent
        calculatorId={modalState.calculatorId}
        resourceId={modalState.resourceId}
        contentId={modalState.contentId}
        isOpen={modalState.isOpen}
        onClose={closeModal}
      />
    </>
  );
};

ContentLink.propTypes = {
  contentId: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  useModalHook: PropTypes.func.isRequired,
  modalComponent: PropTypes.elementType.isRequired,
};

export default ContentLink;
